import { render, staticRenderFns } from "./MCommunicationTest.vue?vue&type=template&id=330e2662&scoped=true&"
import script from "./MCommunicationTest.vue?vue&type=script&lang=js&"
export * from "./MCommunicationTest.vue?vue&type=script&lang=js&"
import style0 from "./MCommunicationTest.vue?vue&type=style&index=0&id=330e2662&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330e2662",
  null
  
)

export default component.exports